export const SLATETOKEN = "slate-token";
export const SLATEUSER = "slate-user";
export const ADMINUSER = "admin-user";

export const setToken = (token) => sessionStorage.setItem(SLATETOKEN, token);
export const getToken = () => sessionStorage.getItem(SLATETOKEN);
export const clearToken = () => sessionStorage.removeItem(SLATETOKEN);
export const setUser = (user) =>
  localStorage.setItem(SLATEUSER, JSON.stringify(user));

export const setAdminUser = (user) =>
  localStorage.setItem(ADMINUSER, JSON.stringify(user));

export const getAdminUser = () => {
  const adminUser = localStorage.getItem(ADMINUSER);
  return adminUser ? JSON.parse(adminUser) : null;
};

export const getUser = () => {
  const userData = localStorage.getItem(SLATEUSER);
  return userData ? JSON.parse(userData) : null;
};

export const clearAuth = (user) => {
  localStorage.removeItem(SLATEUSER);
  sessionStorage.removeItem(SLATETOKEN);
  localStorage.removeItem(ADMINUSER);
  localStorage.removeItem("activePath");
  // setAuthToken(null);
};
